import type { User } from "firebase/auth";
import { isFirebaseConfigured } from "@/auth/firebase";
import { loadCharacterProfile } from "@/character/storage";
import { callSyncPublicStats } from "@/cloud/game-callables";
import { loadHomeEconomyFromIdb } from "@/home/home-idb";
import { createDefaultHomeEconomy } from "@/home/economy";
import { loadTowerProgress } from "@/tower/tower-storage";

export async function syncPlayerPublicStats(user: User): Promise<void> {
  if (!isFirebaseConfigured()) return;
  const profile = loadCharacterProfile(user.uid);
  if (!profile) return;
  const economy = (await loadHomeEconomyFromIdb(user.uid)) ?? createDefaultHomeEconomy();
  const tower = loadTowerProgress(user.uid);
  try {
    await callSyncPublicStats({
      displayName: profile.name,
      towerHighestCleared: tower.highestCleared,
      wealthCoins: economy.wallet.coins,
    });
  } catch {
    /* best-effort */
  }
}
